import BaseService from "../baseService";
class NfeNcm extends BaseService {
  constructor(id) {
    const resource = "nfe-ncm";
    let relationship = {
      // centroCusto:"centro-custo",
      contabilizar: "contabilizar",
      // contaContabil:"conta-contabil",
      // ncm:"ncm",
      // rateio:"rateio"
    };
    super(id, relationship, resource);
  }
}

export default (id) => new NfeNcm(id);
